import { useState, useEffect, useCallback } from 'react';
import { navLinks, siteInfo } from '@/mocks/home-data';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className="flex items-center gap-2 text-xl md:text-2xl font-heading text-foreground-900 no-underline cursor-pointer whitespace-nowrap"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-md text-sm font-bold">
              爆
            </span>
            {siteInfo.name}
          </a>

          <nav className="hidden md:flex items-center gap-1">
            <a
              href="#hero"
              onClick={(e) => handleNavClick(e, '#hero')}
              className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-md cursor-pointer whitespace-nowrap"
            >
              首页
            </a>
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-md cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <nav className="md:hidden pb-4 border-t border-background-200/50 mt-2 pt-3">
            <a
              href="#hero"
              onClick={(e) => handleNavClick(e, '#hero')}
              className="block px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md cursor-pointer"
            >
              首页
            </a>
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="block px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}